export default function Logo({ light = false, className = "" }) {
  return (
    <img
      src="/images/logo.png"
      alt="Beauté Solutions — Cosmetic Esthetics"
      data-testid="logo"
      className={`h-14 w-auto ${className}`}
      style={{ mixBlendMode: light ? "normal" : "normal" }}
    />
  );
}
